import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OrderDetailsPage } from './order-details';

@NgModule({
  declarations: [
    OrderDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(OrderDetailsPage),
  ],
})
export class OrderDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-details/order-details.module.ts